module.exports = __webpack_public_path__ + "static/img/bg-es.f2e5336b.webp";